var map = {
	"./1_Felicitas_Ernst_KERMATO_advertising_3.webp": "./src/img/brands/kermato/1_Felicitas_Ernst_KERMATO_advertising_3.webp",
	"./2_Felicitas_Ernst_KERMATO_advertising_1.webp": "./src/img/brands/kermato/2_Felicitas_Ernst_KERMATO_advertising_1.webp",
	"./3_Felicitas_Ernst_KERMATO_advertising.webp": "./src/img/brands/kermato/3_Felicitas_Ernst_KERMATO_advertising.webp",
	"./Felicitas_Ernst_KERMATO_advertising_2.webp": "./src/img/brands/kermato/Felicitas_Ernst_KERMATO_advertising_2.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/brands/kermato sync \\.(webp%7Cjpg%7Cjpeg%7Cpng)$";